import apiService from './api/api.service';

const mentorBankDetailsService = {
  // Get mentor's bank details
  getBankDetails: async () => {
    try {
      const response = await apiService.get('/mentor-bank-details');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create or update bank details
  saveBankDetails: async (bankData) => {
    try {
      const response = await apiService.post('/mentor-bank-details', bankData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete bank details
  deleteBankDetails: async () => {
    try {
      const response = await apiService.delete('/mentor-bank-details');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default mentorBankDetailsService;
